<template>
  <resize-table
    :scroll="{ x: 200, y: detail.referPriceSource ?  height - 35 : height + 10 }"
    :columns="nutritionColumns"
    bordered
    :loading="nutritonListLoading"
    :data-source="list.records"
    :row-key="record => record.id"
    :pagination="false"
    tableName="Nutritions"
  >
    <span slot="customTitle"><a-icon @click="fixedCol"  type="pushpin" :theme="filled ? 'filled' : 'outlined'" /> 指标名称</span>
    <template slot="nutritionName" slot-scope="text,item">
      <a-tooltip size="small">
        <a @click="viewNut(item)" class="nameStyle">{{text}}</a>
        <!-- <template slot="title">查看养分贡献</template> -->
        <template slot="title">{{text}}</template>
      </a-tooltip>
    </template>
    <!-- <template slot="content" slot-scope="text,record">
      {{ text === '' || text === null ? text : Number(text).toFixed(record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2)}}
    </template> -->
    <template
      v-for="twin in ['cost', 'minApply', 'maxApply','minLimitValue','maxLimitValue']"
      :slot="twin"
      slot-scope="text,record"
    >
      <span :key="twin" v-if="twin === 'cost'">{{text ? text.toFixed(3) : ''}}</span>
      <span v-else :key="twin">
        <span v-if="twin === 'minLimitValue' || twin === 'maxLimitValue'">{{text || text === 0 ? text.toFixed(len(record)) : ''}}</span>
        <span v-else>
          <span v-if="['minApply', 'maxApply'].includes(twin)">{{text || text === 0 ? text.toFixed(3) : ''}}</span>
          <span v-else>{{text ? text.toFixed(3) : ''}}</span>
        </span>
      </span>
      <!-- {{ text ? Number(text).toFixed(3) : ''}} -->
    </template>
    <template
      slot="content"
      slot-scope="text,record"
    >
      {{ text === '' || text === null ? text : Number(text).toFixed(len(record))}}
    </template>
    <template
      v-for="col in ['minValue', 'maxValue']"
      :slot="col"
      slot-scope="text, record"
    >
      <cell-editor :len="len(record)" :item="record" :key="col" :name="col" @blur="target => itemUpdate(target,record.id)" :text="text" :actions="update" :precision='len(record)' :background="true" />
    </template>
    <template slot="option" slot-scope="text,record">
      <a-space v-if="record.editable">
        <a-button type="primary" size="small" @click="() =>saveHandle(record.id)" :loading="updateLoading" style="font-size:12px">保存</a-button>
        <a-button size="small" style="font-size:12px" @click="() => cancelHandle(record.id)">取消</a-button>
      </a-space>
      <span v-else class="save_class">
        <a-button size="small" type="link" @click="() => eidtorItem(record.id)">编辑</a-button>
      </span>
    </template>
    <template slot="productContent" slot-scope="text,record">
      {{text|numberFixed(record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2)}}
    </template>
  </resize-table>
</template>
<script>
import { nhfMixins } from '../../untils'
import CellEditor from './CellEditor.vue'
export default {
  components:{CellEditor},
  mixins:[nhfMixins],
  props:{
    rawsType:{
      type: String,
      default: ''
    },
    columns:{
      type: Array
    },
    tableX: Number,
    hasProductVersion: Boolean
  },
  data(){
    return {
      nutritonListLoading:false,
      priceSource:null,
      chooseVisible:false,
      list:{
        records:[]
      },
      // 指标名称、指标全称、数值、单位、最小值、最大值、单位成本、适用下限、适用上限、极下限、极上限
      detailVisible:false,
      selectItem:{},
      filled: true,
      cacheData: []
    }
  },
  computed:{
    listData(){
      return {
        rawIds:this.selectedRowKeys.join(),
        formulaId:this.formulaId
      }
    },
  },
  mounted(){
    this.getList()
    this.setState({nutVisible: false})
  },
  methods:{
    changeColumns(){
      let nutritionColumns = [...this.nutritionColumns]
      if(this.filled){
        nutritionColumns[0].fixed = 'left'
      }else{
        delete nutritionColumns[0].fixed
      }
      this.setState({nutritionColumns})
    },
    fixedCol(e){
      this.filled = !this.filled
      this.changeColumns()
      e = e || window.event;  
      if(e.stopPropagation) { //W3C阻止冒泡方法  
          e.stopPropagation();  
      } else {  
          e.cancelBubble = true; //IE阻止冒泡方法  
      }
    },
    changeRaw(){
      let newData = this.cacheData ? this.cacheData.concat() || [] : []
      if(this.rawsType === 'all'){
        this.list.records = newData
      }else if(this.rawsType === '1'){
        this.list.records = newData.filter(v => v.content && Number(v.content.toFixed(3)) > 0)
      }else if(this.rawsType === '2'){
        this.list.records = newData.filter(v => v.minValue||v.minValue === 0
        ||v.maxValue||v.maxValue === 0
        ||v.minLimitValue||v.minLimitValue === 0
        ||v.maxLimitValue||v.maxLimitValue === 0
        )
      }
    },
    listChange(page){
      this.getList({...this.tablePageChange(page),...this.filterData})
    },
    viewNut(nutSelect){
      nutSelect.tabKey = 2
      this.setState({nutSelect})
      if(!this.nutVisible) this.setState({nutVisible: true})
      // this.toggleVisible('nutBox')
    },
    len(record){ 
      return record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2
    },
    itemUpdate(item,id){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const targets = newData.filter(item => id === item.id)[0]
      const targetCache = newCacheData.filter(item => id === item.id)[0]
      if (targets && targetCache) {
        this.list.records = newData
        Object.assign(targetCache, item)
        Object.assign(targets, item)
        this.cacheData = newCacheData
        this.list.records = newData
      }
    },
    saveHandle(key){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const target = newData.filter(item => key === item.id)[0]
      const targetCache = newCacheData.filter(item => key === item.id)[0]
      if (target && targetCache) {
        delete target.editable
        this.list.records = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
        this.update(target)
      }
    },
    cancelHandle(id){
      let newData = [...this.list.records]
      let target = newData.filter(item => id === item.id)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.filter(item => id === item.id)[0]);
        target.editable = false
        this.list.records = newData
      }
    },
    eidtorItem(id){
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.id)[0]
      this.editingKey = id
      if (target) {
        target.editable = true
        this.list.records = newData
      }
    },
    async update(arg){
      // this.nutritonListLoading = true
      let data = JSON.parse(JSON.stringify(arg))
      delete data.nutritionFullName
      const response  = await this.fetchPost({
        actions:this.mixTotalUpdate,
        data,
        showMessage:false
      })
      if(response.code === 200){
        await this.fetchPost({
          actions: this.mixTotalUpdateCache,
          data,
          showMessage: false
        });
      }
      setTimeout(() => {
        this.changeRaw()
      }, 0);
      this.$emit('refresh',false,false)
    },
    getList(arg = {},sorter){
      this.$nextTick(async ()=>{
        this.list.records = []
         let res = await this.fetchGet({
          isList:true,
          loading:'nutritonListLoading',
          actions:this.supplementPage,
          name:'list',
          sorter,
          data:{
            formulaId:this.formulaId,
            ...arg,
            size:1000
          }
        })
        this.cleanSelect()
        let {data} = res || {}
        let {records} = data || {}
        this.cacheData = records.concat()
        this.changeRaw()
      })
    },
  }
}
</script>